import { z } from 'zod';

import { VISIBILITY_SCOPE } from '../constants';

/**
 * Zod schema for the PATCH /suppliers/{de_id}/responsible_persons/{user_id}
 * request payload (SupplierResponsiblePersonScopeUpdate).
 */
export const zodUpdateSupplierResponsiblePersonScopePayloadSchema = z.object({
  visibilityScope: z.enum(VISIBILITY_SCOPE),
});
